<template>
  <div class="map-search-wrap">
    <div class="map-search-inner" :class="{ focused: isFocused }">
      <v-icon class="search-icon" size="18" color="#6b7280">mdi-magnify</v-icon>
      <input
        ref="input"
        v-model="query"
        type="text"
        class="search-input"
        :placeholder="placeholder"
        @input="onInput"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @keydown.enter="doSearch"
        @keydown.esc="clear"
      />
      <v-icon
        v-if="query"
        class="clear-icon"
        size="16"
        color="#9ca3af"
        @click="clear"
        style="cursor:pointer"
      >mdi-close-circle</v-icon>
    </div>

    <!-- Results dropdown -->
    <transition name="results-slide">
      <div class="search-results" v-if="results.length">
        <div
          v-for="r in results.slice(0, 6)"
          :key="r.id"
          class="search-result-item"
          @click="selectResult(r)"
        >
          <v-icon size="14" color="#6b7280" class="mr-1">mdi-map-marker</v-icon>
          <span class="result-text">{{ getResultLabel(r) }}</span>
          <span class="result-layer">{{ r.layerId }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MapSearch',
  props: {
    placeholder: { type: String, default: 'Search name, district, ID…' },
    searchManager: { type: Object, default: null },
  },
  data() {
    return {
      query:    '',
      results:  [],
      isFocused:false,
      debounceTimer: null,
    };
  },
  methods: {
    onInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        if (!this.searchManager) return;
        this.results = this.searchManager.searchAll(this.query);
        if (this.results.length === 1) this.selectResult(this.results[0]);
      }, 300);
    },
    doSearch() {
      if (!this.searchManager || !this.query.trim()) return;
      const result = this.searchManager.search(this.query);
      if (result) this.selectResult(result);
    },
    selectResult(result) {
      this.results = [];
      this.query   = '';
      this.$emit('result-selected', result);
    },
    clear() {
      this.query   = '';
      this.results = [];
    },
    getResultLabel(r) {
      if (!r.data) return r.id;
      return r.data.name || r.data.hospitalName || r.data._id || r.id;
    },
  },
};
</script>

<style scoped>
.map-search-wrap {
  position: relative;
  width: 280px;
}

.map-search-inner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 10px;
  padding: 9px 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  border: 1.5px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.map-search-inner.focused {
  border-color: #de520c;
  box-shadow: 0 4px 24px rgba(222, 82, 12, 0.18);
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: poppinsregular, 'Poppins', sans-serif;
  font-size: 13px;
  color: #1f2937;
}

.search-input::placeholder { color: #9ca3af; }

.search-results {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.14);
  overflow: hidden;
}

.search-result-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  gap: 4px;
  transition: background 0.12s;
}
.search-result-item:hover { background: #f3f4f6; }

.result-text {
  flex: 1;
  font-family: poppinsregular, sans-serif;
  font-size: 12.5px;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-layer {
  font-size: 10px;
  color: #9ca3af;
  margin-left: 6px;
  text-transform: capitalize;
}

.results-slide-enter-active, .results-slide-leave-active {
  transition: opacity 0.15s, transform 0.15s;
}
.results-slide-enter, .results-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
